"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapLayoutGrid = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("../../redux/selectors");
var _SiteCardDataWrap = require("./SiteCardDataWrap");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MapLayoutGrid = _ref => {
  let {
    filteredIdList = []
  } = _ref;
  const [swiper, setSwiper] = (0, _react.useState)(null);
  const isSignalSite = (0, _reactRedux.useSelector)(_selectors.getIsSingleSite);
  const activeSiteId = (0, _reactRedux.useSelector)(_selectors.selectActiveSiteId);
  const sitesLength = (0, _reactRedux.useSelector)(_selectors.getDataSitesLength);
  (0, _react.useEffect)(() => {
    if (filteredIdList.length > 1 && activeSiteId && swiper) {
      const activeSlideIndex = filteredIdList.findIndex(id => id === activeSiteId);
      const slideTransitionTime = 500;
      swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(activeSlideIndex - 1, slideTransitionTime);
    }
  }, [activeSiteId, swiper, filteredIdList]);
  const showLoading = isSignalSite || !filteredIdList.length && !sitesLength;
  if (showLoading) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        height: '200px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      sx: {
        color: _constants.colors['main-color-cl-01']
      }
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_paulCorePackage.SwiperLayoutGrid, {
    onSwiper: setSwiper,
    keys: filteredIdList,
    spaceBetween: 38,
    slidesPerView: 6,
    navigation: true,
    grabCursor: true
  }, filteredIdList.map((id, index) => /*#__PURE__*/_react.default.createElement(_SiteCardDataWrap.SiteCardDataWrap, {
    key: id,
    id: id,
    index: index
  })));
};
exports.MapLayoutGrid = MapLayoutGrid;
MapLayoutGrid.propTypes = {
  filteredIdList: _propTypes.default.arrayOf(_propTypes.default.string)
};